import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import MediaPicker from "@/components/common/MediaPicker";
import FieldHint from "@/components/common/FieldHint";
import { inspirationHintRegistry } from "@/lib/webHints/inspiration";
import type { ActivityTabProps } from "./types";

export default function GalleryTab({ form }: ActivityTabProps) {
  const { t } = useTranslation();
  const { control } = form;

  return (
    <div className="card">
      <h2 className="mb-4 text-lg font-semibold text-gray-900 dark:text-white">
        {t("content.activities.gallery.title")}
      </h2>
      {/* Galerijní místo: hlavní fotka téhož formuláře pro akci „Nastavit jako hlavní“ (F7.12). */}
      <Controller
        name="featuredImageId"
        control={control}
        render={({ field: primaryField }) => (
          <Controller
            name="galleryImageIds"
            control={control}
            render={({ field }) => (
              <MediaPicker
                mode="multiple"
                folder="activities"
                value={field.value}
                onChange={field.onChange}
                primary={{ value: primaryField.value ?? null, onChange: primaryField.onChange }}
              />
            )}
          />
        )}
      />
      <FieldHint registry={inspirationHintRegistry} field="galleryImageIds" variant="inspiration" />
    </div>
  );
}
